export const isObject = (obj: unknown): obj is Record<PropertyKey, unknown> =>
  typeof obj === 'object' && obj !== null
